import {
  Checkbox,
  Grid,
  Typography,
  FormGroup,
  FormControlLabel,
  Button,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { memo, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import {
  getAllStorage,
  getData,
  storeData,
  callChoice,
} from "../../utils/GlobalHelper";
import HeaderPage from "../../components/HeaderPage/Index";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import PanelScrollBar from "../../components/BoxRightContent/PanelScrollBar";
import clsx from "clsx";
import GlobalApi from "../../utils/GlobalApi";
import Loading from "../../components/loading/loading";
import ButtonConcent from "../../components/BoxRightContent/ButtonConcent";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import Configs from "../../constants/Configs";
import qs from "qs";
import { isEmpty } from "lodash";
import { API_CODE_SUCCESS } from "../../constants/CommonConstant";
import { Idc } from "../../utils/GlobalKey";

const useStyle = makeStyles({
  font: {
    fontFamily: "DB Heavent",
  },
  content: {
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "var(----text-black)",
  },
});

const IslamCon = (props) => {
  const classes = useStyle();
  const [lang, setLang] = useState(getData("lang"));
  const [translations, setTranslations] = useState("");
  const [isRead, setIsRead] = useState(false);
  const [checked, setChecked] = useState(false);
  const [callFinished, setCallFinished] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModel, setIsModel] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
  );
  const [consent, setConsent] = useState({
    checkboxText: "",
    termConText: "",
    titleText: "",
    btnOk: "",
    btnCancel: "",
  });
  const [isModelFailed, setIsModelFailed] = useState(false);
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const token = getData("HeaderManp") ? getData("HeaderManp")?.token : "";
  const [isForeignRequest, setIsForeignRequest] = useState(false);

  const header = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json",
    },
  };
  const [jumpPage, setJumpPage] = useState(false);
  const [textFinished, setTextFinished] = useState({
    title: "",
    message: "",
    btn: "",
  });
  const idc = getData("idc");
  const REDIRECT_URL = "https://www.daolsecurities.co.th";
  const STORAGE_KEY = "open_complete";
  const REDIRECTED_KEY = "has_redirected";

  const callGetConsent = async () => {
    setIsLoading(true);
    try {
      const header = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      await GlobalApi.get(Configs.baseURL + "/api/consent?id=islam", header)
        .then((res) => {
          setIsLoading(false);
          res?.data?.data.forEach((row) => {
            setConsent({
              checkboxText: row?.checkBox,
              termConText: row?.detail,
              titleText: row?.title,
              btnOk: row?.okBtn,
              btnCancel: row?.cancelBtn ? row?.cancelBtn : "",
            });
          });
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleNext = async () => {
    if (isForeignRequest) {
      props.history.push("fif_consent");
    } else {
      callFinish();
    }
  };

  const callFinish = async () => {
    const atsDataUser = getData("atsDataUser") || {};
    const { bankCode } = atsDataUser;
    const f7_ats = getData("f7_ats") || {};
    const { f7_isother } = f7_ats;
    setIsLoading(true);
    setCallFinished(true);
    try {
      const res = await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/finished`,
        {
          head_token: head_token,
          comfrimation: 1,
          use_other_bank: parseInt(f7_isother),
        },
        { headers: { "content-type": "application/json" } },
      );
      if (!res.data) {
        setCallFinished(false);
        setIsModelFailed(true);
        setTextFinished({
          title: translations?.[lang]?.textFinishFailed?.title,
          message: translations?.[lang]?.textFinishFailed?.message,
          btn: translations?.[lang]?.textFinishFailed?.btn,
        });
        setIsModel(true);
        setIsLoading(false);
        return;
      }
      // ✅ เรียก 2 ฟังก์ชันหลักและรอให้สำเร็จ
      await saveComeback();
      await deleteCase();
    } catch (error) {
      console.error("เกิดข้อผิดพลาดใน callFinish:", error);
      setIsModelFailed(true);
      setCallFinished(false);
      setTextFinished({
        title: translations?.[lang]?.textFinishFailed?.title,
        message: "ไม่สามารถทำรายการได้ กรุณาลองใหม่อีกครั้ง",
        btn: translations?.[lang]?.textFinishFailed?.btn,
      });
      setIsModel(true);
    }
  };

  const saveComeback = async () => {
    storeData("stamp_page", "FINISH");
    const last_stamp = JSON.stringify(await getAllStorage("FINISH"));
    const saveData = [
      {
        name: "comeback",
        url: `${Configs.baseAPIURL03}/form/comeback/manp`,
        postData: {
          head_token: head_token,
          last_stamp: last_stamp,
          stamp_page: "FINISH",
        },
      },
    ];

    try {
      const response = await GlobalApi.post(
        saveData[0].url,
        qs.stringify(saveData[0].postData),
        header,
      );

      setIsLoading(false);

      const isSuccess = response?.data?.Data?.[0]?.[0]?.IsSuccess === 1;

      if (!isSuccess) {
        const msgDesc = response?.data?.Data?.[0]?.MsgDesc || "";
        const message =
          msgDesc !== ""
            ? msgDesc
            : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";

        setIsModelFailed(true);
        setTextFinished({
          title: translations?.[lang]?.textFinishFailed?.title,
          message: translations?.[lang]?.textFinishFailed?.message,
          btn: translations?.[lang]?.textFinishFailed?.btn,
        });
        setIsModel(true);
        return;
      }

      const hasRiskGroup =
        getData("riskGroupCurrent") ||
        getData("riskGroupIdc") ||
        getData("riskGroupWorkPlace") ||
        getData("riskGroupCareer") ||
        getData("riskGroupBusiness");

      setTextFinished(
        hasRiskGroup
          ? {
              title: translations?.[lang]?.textFinishRisk3?.title,
              message: translations?.[lang]?.textFinishRisk3?.message,
              btn: translations?.[lang]?.textFinishRisk3?.btn,
            }
          : {
              title: translations?.[lang]?.textFinished?.title,
              message: translations?.[lang]?.textFinished?.message,
              btn: translations?.[lang]?.textFinished?.btn,
            },
      );
      // ✅ สำเร็จ: ล้างรูปภาพ
      await clearImage();
      window.localStorage.clear(); // clear หลังอ่านแล้ว

      setIsModel(true);
    } catch (error) {
      setIsLoading(false);

      const apiError = getData("api_error")?.message || "ไม่ทราบสาเหตุ";
      const errorMessage =
        "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" + apiError + ")";

      setIsModelFailed(true);
      setTextFinished({
        title: translations?.[lang]?.textFinishFailed?.title,
        message: errorMessage,
        btn: translations?.[lang]?.textFinishFailed?.btn,
      });
      setIsModel(true);
    }
  };

  const deleteCase = async () => {
    const saveData = {
      url: `${Configs.baseURL}/case/delete`,
      postData: {
        safh_id: token,
      },
    };
    try {
      const response = await GlobalApi.delete(saveData.url, saveData.postData);
    } catch (error) {
      setIsLoading(false);
      const apiError = getData("api_error")?.message || "ไม่ทราบสาเหตุ";
      const errorMessage =
        "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" + apiError + ")";
      setIsModelFailed(true);
      setTextFinished({
        title: translations?.[lang]?.textFinishFailed?.title,
        message: errorMessage,
        btn: translations?.[lang]?.textFinishFailed?.btn,
      });
      setIsModel(true);
    }
  };

  const onConfirm = (read) => {
    setIsRead(read);
  };

  useEffect(() => {
    // ถ้ากด back กลับมา → ไป index
    const hasRedirected = localStorage.getItem(REDIRECTED_KEY);
    if (hasRedirected) {
      localStorage.removeItem(REDIRECTED_KEY);
      props.history.replace("/");
      return;
    }

    // tab อื่น redirect ตาม
    const handleStorage = (e) => {
      if (e.key === STORAGE_KEY && e.newValue) {
        try {
          const data = JSON.parse(e.newValue);
          if (data.type === "REDIRECT") {
            localStorage.setItem(REDIRECTED_KEY, "true");
            window.location.replace(data.url);
          }
        } catch (err) {}
      }
    };

    // bfcache (Safari)
    const handlePageShow = (e) => {
      if (e.persisted && localStorage.getItem(REDIRECTED_KEY)) {
        localStorage.removeItem(REDIRECTED_KEY);
        props.history.replace("/");
      }
    };

    window.addEventListener("storage", handleStorage);
    window.addEventListener("pageshow", handlePageShow);
    return () => {
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  const popUps = () => {
    localStorage.setItem(REDIRECTED_KEY, "true");
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ type: "REDIRECT", url: REDIRECT_URL, t: Date.now() }),
    );
    window.location.replace(REDIRECT_URL);
  };

  const clickBack = () => {
    const tcconfirm = getData("tcconfirm");
    if (tcconfirm?.confirm === 1) {
      props.history.push("/summary");
    } else {
      props.history.push("/tc_confirm");
    }
  };
  const clearImage = async () => {
    try {
      var postData = {
        head_token,
      };
      await GlobalApi.post(
        `${Configs.baseURL}/api/clearupload`,
        qs.stringify(postData),
        header,
      )
        .then(async (res) => {
          setIsLoading(false);
          // console.log(res);
        })
        .catch((er) => {
          // console.log(er);
          setIsLoading(false);
          let title = "เกิดข้อผิดพลาด";
          let mss =
            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
            getData("api_error")?.message +
            ")";
          setIsModalError(true);
          setModalErrorTitle(title);
          setModalErrorDes(mss);
        });
    } catch (error) {
      // console.log(error);
      setIsLoading(false);
      let title = "เกิดข้อผิดพลาด";
      let mss =
        "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
        getData("api_error")?.message +
        ")";
      setIsModalError(true);
      setModalErrorTitle(title);
      setModalErrorDes(mss);
    }
    return;
  };

  const getValidateFIFConsent = async () => {
    try {
      setIsLoading(true);
      const header = {
        headers: {
          Accept: "application/json",
        },
      };
      let isForeignForAccept = false;
      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/product/selbyhead`,
        { head_token: head_token },
        header,
      )
        .then((res) => {
          if (
            res &&
            res.status === API_CODE_SUCCESS &&
            res.data &&
            res.data.Data
          ) {
            res.data.Data.forEach((section) => {
              section.items.forEach((item) => {
                if (item.investment_id === 5 && item.selected === 1) {
                  isForeignForAccept = true;
                }
              });
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
        });

      const idCard = getData(Idc) ? getData(Idc).idCard : "";
      if (isForeignForAccept && idCard) {
        await GlobalApi.post(
          `${Configs.baseAPIURL03}/form/consent/selbyhead`,
          {
            head_token: head_token,
            card_id: idCard,
          },
          header,
        )
          .then((res) => {
            if (
              res &&
              res.status === API_CODE_SUCCESS &&
              res.data &&
              res.data.Data &&
              res.data.Data[0]
            ) {
              let isSuccess = res.data.Data[0].IsSuccess;
              if (Number(isSuccess) === 1) {
                isForeignForAccept = false;
              }
            }
            setIsLoading(false);
          })
          .catch((err) => {
            // console.log(err);
            setIsLoading(false);
          });
      }
      setIsForeignRequest(isForeignForAccept);
    } catch (error) {
      // console.log(error);
      setIsLoading(false);
    }
  };

  useEffect(async () => {
    const translation = getData("Translations");
    if (!isEmpty(translation)) {
      setTranslations(translation);
    } else {
      props.history.push("/");
    }

    await callGetConsent();
    await getValidateFIFConsent();
  }, []);

  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.tcconfirm?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? clickBack() : "")}
          />
          <Loading status={isLoading} />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.islam_condition}
                        clickBack={(e) => clickBack()}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content content-islam">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          {" "}
                          <HeaderRight
                            title={translations?.[lang]?.islam_condition?.title}
                          />
                          <PanelScrollBar
                            content={
                              <Grid container>
                                <Grid className="sub-title">
                                  <Typography
                                    className="box-title text-left font-20 pt-2"
                                    dangerouslySetInnerHTML={{
                                      __html: consent.titleText,
                                    }}
                                  ></Typography>
                                </Grid>
                                <Grid className={classes.content}>
                                  <Grid
                                    className={clsx(classes.font, "font-20")}
                                    dangerouslySetInnerHTML={{
                                      __html: consent.termConText,
                                    }}
                                  ></Grid>
                                </Grid>
                              </Grid>
                            }
                            // confirmRead={onConfirm}
                          />{" "}
                          {/* button */}
                          <ButtonConcent
                            tcconfirm
                            textOk={consent?.btnOk}
                            textCancel={consent?.btnCancel}
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <DialogCustoms
              imgModalFinished
              open={isModel}
              isModel={setIsModel}
              switchType={(e) => {
                if (isModelFailed) {
                  setIsModelFailed(false);
                  setIsModel(false);
                } else {
                  popUps(e);
                }
              }}
              title={textFinished?.title}
              massage={textFinished?.message}
              btnPrimary={textFinished?.btn}
            />
            <DialogCustoms
              imgModalError
              open={isModalError}
              isModel={modalErrorTitle}
              switchType={(e) => setIsModalError(false)}
              title={modalErrorTitle}
              massage={modalErrorDes}
              btnPrimary={"ยอมรับ"}
            />
          </Grid>
        </>
      )}
    </>
  );
};

export default memo(IslamCon);
